// ============================================
// モジュール読み込み
// ============================================
import { viewport } from "./libs/switchViewport";
import {
  imgAnim,
  imgUp,
  inViewAnm,
  lenisPageScroll,
  movieAnim,
  navWhite,
  textAnm,
} from "./libs/Scroll";
import { drawer, fixedHeader } from "./libs/Header";
// import { accordionFunc } from './libs/Accordion';
import { addAutoFunc, numKeyFunc } from "./libs/Form";
// import { articleTable, ScrollHintFunc } from './libs/ScrollHint';
import {
  archiveSlider,
  introSlider,
  propertyImg,
  propertyMv,
} from "./libs/Slider";
import { topMap } from "./libs/Hover";
// import { tabFunc } from './libs/Tab';

// 実行
// ==========================
window.addEventListener("DOMContentLoaded", () => {
  viewport();
  fixedHeader();
  drawer();
  addAutoFunc();
  numKeyFunc();
  lenisPageScroll();
  imgAnim();
  topMap();
  movieAnim();
  imgUp();
  // accordionFunc();
  // articleTable();
  // ScrollHintFunc();
  // tabFunc();
});

window.addEventListener("load", () => {
  document.body.classList.add("is-loaded");
  introSlider();
  navWhite();
  inViewAnm();
  textAnm();
  propertyMv();
  propertyImg();
  archiveSlider();
});

window.addEventListener("resize", () => {
  if (!document.body.classList.contains("is-resize")) {
    document.body.classList.add("is-resize");
  }
  setTimeout(function () {
    if (document.body.classList.contains("is-resize")) {
      document.body.classList.remove("is-resize");
    }
  }, 500);
});
